import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { filterIndicesSelector } from '@store/comparison/selectors';
import nocSelector from '@store/noc/selectors';
import React from 'react';

import { changeFilterContainerVisibility } from '@store/filterContainer/actions';
import NocComponent from './NocComponent';

const selector = createSelector(
  filterContainerSelector,
  filterIndicesSelector,
  nocSelector,
  (
    filterContainer,
    filterIndices,
    nocStore,
  ) => ({
    filterContainer,
    filterIndices,
    nocStore,
  }),
);

const NocComp = props => <NocComponent {...props} />;

export default connect(selector, {
  changeFilterContainerVisibility,
})(NocComp);
